import Model from "./base/model";

class BillingContractedPriceAdditional extends Model{
  resourceName() {
    return "billing_contracted_price_additionals";
  }

  fields() {
    return {
      quantity: "",
      price: "",
      name: "",
    }
  }
}

export default new BillingContractedPriceAdditional();
